import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M2 12a6 6 0 0 1 6 -6h8a6 6 0 0 1 6 6a6 6 0 0 1 -6 6h-8a6 6 0 0 1 -6 -6","key":"svg-1"}]]

const IconToggleLeft = createReactComponent('outline', 'toggle-left', 'ToggleLeft', __iconNode);

export default IconToggleLeft;